import Router from 'next/router';

export const redirectToLogin = (ctx, baseUrl = '') => {
	const { res, asPath } = ctx;
	const loginUrl = `${baseUrl}/auth`;

	if (res) {
		res.writeHead(302, { Location: loginUrl });
		res.end();
	} else {
		Router.push(loginUrl);
	}
};

export const redirectToPage = (ctx, baseUrl = '') => {
	const { res, asPath } = ctx;

	if (res) {
		res.writeHead(302, { Location: baseUrl });
		res.end();
	} else {
		Router.push(baseUrl);
	}
};

export const activePath = (router, endpoint, query = '') => {
	const paths = router.asPath.split('?')[0]?.split('/') || [];
	const params = router.asPath.split('?')[1]?.split('&') || [];
	return paths[paths.length - 1] === endpoint && (!query || params.includes(query));
};

export const onSafeBack = (router, fallback = '/') => {
	const canGoBack = window.history.state?.idx > 0;
	return canGoBack ? router.back() : router.push(fallback);
};
